module.exports = __webpack_public_path__ + "images/halloween_lp/sec01_banner_1db5ba1ff97641ac46fb5cee8f701dc5.png";